import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function ServiceDetailsSection() {
  const {
    t
  } = useLanguage();
  const [openIndex, setOpenIndex] = useState(-1);
  const serviceDetails = [{
    title: t('details.bespoke'),
    items: [t('details.bespoke.1'), t('details.bespoke.2'), t('details.bespoke.3'), t('details.bespoke.4')]
  }, {
    title: t('details.alterations'),
    items: [t('details.alterations.1'), t('details.alterations.2'), t('details.alterations.3'), t('details.alterations.4')]
  }, {
    title: t('details.restoration'),
    items: [t('details.restoration.1'), t('details.restoration.2'), t('details.restoration.3'), t('details.restoration.4')]
  }];
  return <section className="py-28 lg:py-36 px-6 bg-[#0A0A0A] text-white" data-id="element-220">
      <div className="max-w-5xl mx-auto" data-id="element-221">
        <div className="text-center mb-16" data-id="element-222">
          <h2 className="font-serif text-4xl lg:text-5xl font-light" data-id="element-223">
            {t('details.title')}
          </h2>
        </div>

        {serviceDetails.map((service, index) => <div key={index} className="border-b border-white/5 last:border-b-0" data-id="element-224">
            <button onClick={() => setOpenIndex(openIndex === index ? -1 : index)} className="w-full py-10 lg:py-12 flex items-center justify-between group" data-id="element-225">
              <h3 className="font-serif text-2xl lg:text-4xl text-left group-hover:text-[#D4AF37] transition-colors duration-500 font-light" data-id="element-226">
                {service.title}
              </h3>
              <div className="ml-10" data-id="element-227">
                {openIndex === index ? <Minus size={24} className="text-[#D4AF37]" strokeWidth={1} data-id="element-228" /> : <Plus size={24} className="text-white/30 group-hover:text-[#D4AF37] transition-colors" strokeWidth={1} data-id="element-229" />}
              </div>
            </button>

            {openIndex === index && <div className="pb-12 grid grid-cols-1 md:grid-cols-2 gap-6 animate-in fade-in slide-in-from-top-2 duration-500" data-id="element-230">
                {service.items.map((item, itemIndex) => <div key={itemIndex} className="flex items-center gap-3" data-id="element-231">
                    <div className="w-1.5 h-1.5 bg-[#D4AF37] rounded-full" data-id="element-232"></div>
                    <span className="text-gray-400 font-light text-sm" data-id="element-233">
                      {item}
                    </span>
                  </div>)}
              </div>}
          </div>)}
      </div>
    </section>;
}